import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "../service/Interceptor";
import {
  categoriesAPI,
  domainAPI,
  followUserAPI,
  getProfileUser,
  profileCreationAPI,
  profileImageAPI,
  profilePortfolioAPI,
  unfollowUserAPI,
} from "../service/apiUrl";
import toast from "../components/Toast/toast";
import { sentEmailRequest } from "./requestEmailSlice";

const initialState = {
  userProfile: null,
  otherUserProfile: null,
  businessProfile: null,
  isProfileLoading: true,
  states: [],
  cities: [],
  domains: [],
  categories: [],
  isLoading: false,
  hasError: false,
};

export const getUserProfile = createAsyncThunk(
  "get-user-profile",
  async (_, thunkAPI) => {
    try {
      const res = await API.get(getProfileUser);
      if (res.data.success) {
        const data = res.data.data;
        // console.log('data', data)

        localStorage.setItem("userType", window?.btoa(data?.userType));
        // localStorage.setItem("profileImage", serverFiles(data?.profileUrl));
        return data;
      } else {
        return thunkAPI.rejectWithValue("No message in response");
      }
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue(error.response?.data || "Unknown error");
    }
  }
);

export const getOtherUserProfile = createAsyncThunk(
  "get-visitor-profile",
  async (userId, thunkAPI) => {
    try {
      const res = await API.get(`api/users/${userId}/profile`);
      if (res?.data?.success) {
        const data = res.data.data;

        // console.log(data)
        // localStorage.setItem("profileCompleted")
        // localStorage.setItem("otherUserI", serverFiles(data?.profileUrl));
        return data;
      } else {
        return thunkAPI.rejectWithValue("No message in response");
      }
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue(error.response?.data || "Unknown error");
    }
  }
);

export const getDomains = createAsyncThunk(
  "get-Domains",
  async (_, thunkAPI) => {
    try {
      const res = await API.get(domainAPI);

      return res.data;
      // if (res.data.success) {
      // } else {
      //   return thunkAPI.rejectWithValue("No message in response");
      // }
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue(error.response?.data || "Unknown error");
    }
  }
);

export const getCategories = createAsyncThunk(
  "get-Categories",
  async (_, thunkAPI) => {
    try {
      const res = await API.get(categoriesAPI);
      return res?.data?.data?.results;
      // if (res.data.success) {
      // } else {
      //   return thunkAPI.rejectWithValue("No message in response");
      // }
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue(error.response?.data || "Unknown error");
    }
  }
);

export const getStates = createAsyncThunk("get-States", async (_, thunkAPI) => {
  try {
    const res = await API.get(`api/locations/states`);
    if (res?.data?.success) {
      return res?.data?.data?.results;
    } else {
      return thunkAPI.rejectWithValue("No message in response");
    }
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue(error.response?.data || "Unknown error");
  }
});

export const getCities = createAsyncThunk(
  "get-Cities",
  async (id, thunkAPI) => {
    try {
      const res = await API.get(`api/locations/states/${id}/cities`);

      if (res?.data?.success) {
        return res?.data?.data?.results;
      } else {
        return thunkAPI.rejectWithValue("No message in response");
      }
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue(error.response?.data || "Unknown error");
    }
  }
);

export const uploadProfileImage = createAsyncThunk(
  "profile-img-upload",
  async ({ payload, type }, { rejectWithValue }) => {
    try {
      // null/empty payload clears the photo (backend treats empty file as remove)
      const body = payload ?? new FormData();
      const res = await API.put(profileImageAPI, body);
      if (res?.data?.success) {
        toast.success(res?.data?.message);
        return { response: res.data.data ?? null, type };
      }
      return rejectWithValue(res?.data?.message || "Upload failed");
    } catch (error) {
      toast.error(error);
      return rejectWithValue(
        error?.response?.data?.message || error?.message || "Upload failed"
      );
    }
  }
);

export const profileCreation = createAsyncThunk(
  "profile-creation",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await API.put(profileCreationAPI, payload);
      if (res?.data?.success) {
        return { status: true, data: res.data.data };
      }
      return rejectWithValue(
        res?.data?.message || "Failed to create profile"
      );
    } catch (error) {
      console.log("Profile creation error", error);
      return rejectWithValue(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to create profile"
      );
    }
  }
);

export const uploadProfilePortfolio = createAsyncThunk(
  "portfolio-img-upload",
  async (payload) => {
    try {
      const res = await API.put(profilePortfolioAPI, payload);

      if (res.data.success) {
        // alert("Portfolio Uploaded");
        if (res?.data?.data !== null) toast.success("Uploaded successfully");
        return res.data.data;
      }
    } catch (error) {
      toast.error(error);
    }
  }
);

// export const followUser = createAsyncThunk(
//   "follow-user",
//   async (payload, thunkAPI) => {
//     try {
//       const res = await API.post(followUserAPI, payload);

//       if (res.data.success) {
//         toast.success(res?.data?.message || "User followed");
//         return res?.data?.data;
//       }
//     } catch (error) {
//       console.log("Error in Following an user", error);
//       return thunkAPI.rejectWithValue("Something went wrong");
//     }
//   }
// );

export const followUser = createAsyncThunk(
  "follow-user",
  async ({ payload, postId }, thunkAPI) => {
    try {
      const res = await API.post(followUserAPI, payload);

      if (res?.data?.success) {
        // toast.success(res?.data?.message || "User followed");
        return { res: res?.data?.data, postId };
      }
    } catch (error) {
      console.log("Error in following an user", error);
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

export const unfollowUser = createAsyncThunk(
  "unfollow-user",
  async ({ payload, postId }, thunkAPI) => {
    try {
      const res = await API.post(unfollowUserAPI, payload);

      if (res?.data?.success) {
        // toast.success(res?.data?.message || "User unfollowed");
        return { res: res?.data?.data, postId };
      }
    } catch (error) {
      console.log("Error in unfollowing an user", error);
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const profileSlice = createSlice({
  name: "profileCreation",
  initialState,
  reducers: {
    resetProfileURL: (state) => {
      if (state.userProfile) {
        state.userProfile.profileUrl = null;
        if (state.userProfile.companyResponseDto) {
          state.userProfile.companyResponseDto.logo = null;
        }
      }
    },
    /** Force location labels in Redux after edit (API may still return stale FK names). */
    applyProfileLocation: (state, action) => {
      if (!state.userProfile) return;
      const { cityName, stateName, cityId, stateId } = action.payload || {};
      if (cityName !== undefined) state.userProfile.cityName = cityName || null;
      if (stateName !== undefined) state.userProfile.stateName = stateName || null;
      if (cityId !== undefined) state.userProfile.cityId = cityId;
      if (stateId !== undefined) state.userProfile.stateId = stateId;
      const company = state.userProfile.companyResponseDto;
      if (company) {
        if (cityName !== undefined) company.cityName = cityName || null;
        if (stateName !== undefined) company.stateName = stateName || null;
        if (cityId !== undefined) company.cityId = cityId;
        if (stateId !== undefined) company.stateId = stateId;
      }
    },
    resetPortfolioURL: (state) => {
      state.userProfile.portfolioUrl = null;
    },
    setPortfolioURL: (state, action) => {
      state.userProfile.portfolioUrl = action.payload;
    },
    resetOtherUserProfile: (state) => {
      state.otherUserProfile = {};
    },
    setIsProfileLoading: (state, action) => {
      state.isProfileLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder

      //------------------GET USER PROFILE------------------
      .addCase(getUserProfile.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
        if (!state.userProfile) {
          state.isProfileLoading = true;
        }
      })
      .addCase(getUserProfile.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
        state.isProfileLoading = false;
      })
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        state.isProfileLoading = false;
        state.userProfile = action.payload;
        // state.otherUserProfile = {}
      })
      //-----------------GET OTHER USERS PROFILE ---------------
      .addCase(getOtherUserProfile.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(getOtherUserProfile.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      })
      .addCase(getOtherUserProfile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        state.otherUserProfile = action.payload;
      })
      //------------------GET DOMAINS------------------
      .addCase(getDomains.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(getDomains.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      })
      .addCase(getDomains.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        state.domains = action.payload;
      })

      //------------------GET CATEGORIES------------------
      .addCase(getCategories.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(getCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      })
      .addCase(getCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        state.categories = action.payload;
      })

      //------------------GET STATES------------------
      .addCase(getStates.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(getStates.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      })
      .addCase(getStates.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        state.states = action.payload;
      })

      //------------------GET CITIES------------------
      .addCase(getCities.pending, (state) => {
        state.isLoading = true;
        state.hasError = false;
        // Drop previous state's cities immediately so the UI never shows a mismatch
        state.cities = [];
      })
      .addCase(getCities.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
        state.cities = [];
      })
      .addCase(getCities.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        state.cities = Array.isArray(action.payload) ? action.payload : [];
      })

      //------------------UPLOAD PORTFOLIO------------------
      .addCase(uploadProfilePortfolio.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(uploadProfilePortfolio.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      })
      .addCase(uploadProfilePortfolio.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        state.userProfile.portfolioUrl = action.payload;
      })

      //------------------UPLOAD PROFILE IMAGE------------------
      .addCase(uploadProfileImage.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(uploadProfileImage.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      })
      .addCase(uploadProfileImage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        const url = action.payload?.response ?? null;
        if (state.userProfile) {
          state.userProfile.profileUrl = url;
          if (state.userProfile.companyResponseDto) {
            state.userProfile.companyResponseDto.logo = url;
          }
        }
      })

      //------------------CREATE A PROFILE------------------
      .addCase(profileCreation.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(profileCreation.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      })
      .addCase(profileCreation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        if (action.payload?.data) {
          state.userProfile = {
            ...state.userProfile,
            ...action.payload.data,
          };
        }
      })

      //------------------FOLLOW A USER------------------
      .addCase(followUser.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(followUser.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      })
      .addCase(followUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        state.otherUserProfile.isFollowed = true;
        state.otherUserProfile.followerCount++;
      })

      //------------------UNFOLLOW USER------------------
      .addCase(unfollowUser.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(unfollowUser.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      })
      .addCase(unfollowUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        state.otherUserProfile.isFollowed = false;
        state.otherUserProfile.followerCount =
          state.otherUserProfile.followerCount - 1;
      })
      .addCase(sentEmailRequest.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        state.otherUserProfile.status = true;
      });
  },
});

export const {
  resetProfileURL,
  applyProfileLocation,
  resetPortfolioURL,
  resetOtherUserProfile,
  setIsProfileLoading,
  setPortfolioURL,
} = profileSlice.actions;
export default profileSlice.reducer;
